import { AxiosResponse } from 'axios';

import { IGift } from '../types/gift';
import { DeclineOptions } from '../constants/unsubscribe.constants';

import http from './api.service';

const unsubscribeUrls = {
  [DeclineOptions.One]: '/unsubscribe/decline',
  [DeclineOptions.All]: '/unsubscribe/all',
};

export const getUnsubscribeUrlByType = (type: DeclineOptions): string => unsubscribeUrls[type];

export const emptyGift = {
  canBeDeclined: true,
  isUnsubscribed: false,
  isFeedbackSent: false,
  sender: {
    fullName: '',
  },
  recipient: {
    id: 0,
    fullName: '',
    email: '',
  },
  company: '',
  outerUnsubscribeUrl: '',
};

interface IGiftResponse {
  gift: IGift;
}

const unsubscribeService = {
  getCommonData: (): Promise<IGift> =>
    http.get<IGiftResponse>('/unsubscribe/data').then(({ data: { gift } }: AxiosResponse<IGiftResponse>) => gift),

  unsubscribe: (type: DeclineOptions, feedback: string): Promise<IGift> =>
    http
      .post<IGiftResponse>(getUnsubscribeUrlByType(type), { feedback })
      .then(({ data: { gift } }) => gift),

  cancel: (): Promise<IGift> => http.post<IGiftResponse>('/unsubscribe/cancel').then(({ data: { gift } }) => gift),
};

export default unsubscribeService;
